<script>
  import { onDestroy } from 'svelte';
  import { update_search } from "./Utils/RouterUtils.svelte";
  import { store } from "./Utils/stores.js";

  let search_term = '';
  const unsubscribe = store.subscribe(value => {
    search_term = value.search || '';
  });
  onDestroy(unsubscribe);

  function handle_submit(evt) {
      update_search(search_term);
  }
</script>

<div class="">
  <form
    on:submit|preventDefault={handle_submit}>
    <div class="vec-flex vec-justify-content-center">
    <div class='md:vec-mx-auto vec-flex vec-justify-center vec-w-full'>
      <input type="search" name="search" id="email"
             bind:value={search_term}
             class="vec-border vec-flex-grow vec-border-gray-500 vec-p-2 vec-shadow-sm
					 vec-block vec-w-full md:vec-w-96 vec-text-sm vec-border-gray-300 vec-rounded-md" placeholder="Search...">
      <button type="submit" class="vec-flex-grow-0 vec-inline-flex vec-items-center vec-justify-center vec-px-4 vec-py-2 vec-border vec-border-transparent vec-shadow-sm vec-font-medium vec-rounded-md
      vec-text-white !vec-bg-darkerGrey hover:!vec-bg-darkGrey focus:outline-none vec-mt-0 vec-ml-3 vec-text-sm">
        Search
      </button>
    </div>

  </form>
</div>
